// Notice channels an organisation can turn on (NoticeChannel minus APP, which is always on).
// Local list: the installed @bciti/types predates NoticeChannel.
export const CONFIGURABLE_NOTICE_CHANNELS = ['EMAIL', 'SMS', 'PUSH', 'VOICE', 'WEB'] as const;

export type ConfigurableNoticeChannel = typeof CONFIGURABLE_NOTICE_CHANNELS[number];

// Shown instead of the value when the value alone is unclear.
export const NOTICE_CHANNEL_LABELS: Partial<Record<ConfigurableNoticeChannel, string>> = { WEB: 'Website' };
